import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import errorIcon from '../../../svg/exclamation-circle.svg';

const TableCell = ({
    id,
    content,
    hasError,
    errorMessage,
}) => {
    let styles = {};
    let icon = null;

    if (hasError) {
        icon = (<img
            key="error-icon"
            className="error-icon inline-block"
            src={ errorIcon }
            title={ errorMessage }
            alt="Cell error icon"
        />);

        styles = {
            color: '#F06D6D',
        };
    }

    return (
        <Fragment>
            <td style={ styles } id={ id }>
                { icon }
                { content }
            </td>
        </Fragment>
    );
};

TableCell.propTypes = {
    id: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    hasError: PropTypes.bool.isRequired,
    errorMessage: PropTypes.string,
};

TableCell.defaultProps = {
    errorMessage: '',
};

export default TableCell;
